// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: webhook.proto

export const protobufPackage = 'compasspb';

/**
 * Which case collection an event comes from: production cases
 * (compass.case_records) or sandbox cases (compass_sandbox.sandbox_case_records).
 * An endpoint only ever receives events of its own environment.
 */
export enum WebhookEnvironment {
  WEBHOOK_ENVIRONMENT_UNSPECIFIED = 0,
  WEBHOOK_ENVIRONMENT_PRODUCTION = 1,
  WEBHOOK_ENVIRONMENT_SANDBOX = 2,
}

export enum WebhookEndpointStatus {
  WEBHOOK_ENDPOINT_STATUS_UNSPECIFIED = 0,
  /** WEBHOOK_ENDPOINT_STATUS_ACTIVE - Matches events and delivers them. */
  WEBHOOK_ENDPOINT_STATUS_ACTIVE = 1,
  /**
   * WEBHOOK_ENDPOINT_STATUS_PAUSED - Still matches events, but they are recorded as cancelled
   * (endpoint_paused) instead of sent, so Resume can replay them.
   */
  WEBHOOK_ENDPOINT_STATUS_PAUSED = 2,
  /** WEBHOOK_ENDPOINT_STATUS_DISABLED - Matches nothing. Resume does not replay. */
  WEBHOOK_ENDPOINT_STATUS_DISABLED = 3,
}

/** Mirrors the dispatcher's delivery status. */
export enum WebhookDeliveryStatus {
  WEBHOOK_DELIVERY_STATUS_UNSPECIFIED = 0,
  /** WEBHOOK_DELIVERY_STATUS_PENDING - Recorded; first attempt not yet made. */
  WEBHOOK_DELIVERY_STATUS_PENDING = 1,
  /** WEBHOOK_DELIVERY_STATUS_RETRYING - At least one failed attempt; more are scheduled. */
  WEBHOOK_DELIVERY_STATUS_RETRYING = 2,
  /** WEBHOOK_DELIVERY_STATUS_SUCCEEDED - The receiver answered 2xx. */
  WEBHOOK_DELIVERY_STATUS_SUCCEEDED = 3,
  /** WEBHOOK_DELIVERY_STATUS_EXHAUSTED - Retries ran out or a non-retryable failure occurred (see last_error_class). */
  WEBHOOK_DELIVERY_STATUS_EXHAUSTED = 4,
  /** WEBHOOK_DELIVERY_STATUS_CANCELLED - Endpoint paused, disabled or deleted (see cancel_reason). */
  WEBHOOK_DELIVERY_STATUS_CANCELLED = 5,
}

/** Outcome of a single HTTP attempt. */
export enum WebhookAttemptOutcome {
  WEBHOOK_ATTEMPT_OUTCOME_UNSPECIFIED = 0,
  /** WEBHOOK_ATTEMPT_OUTCOME_SUCCESS - 2xx */
  WEBHOOK_ATTEMPT_OUTCOME_SUCCESS = 1,
  /** WEBHOOK_ATTEMPT_OUTCOME_CLIENT_ERROR - 4xx */
  WEBHOOK_ATTEMPT_OUTCOME_CLIENT_ERROR = 2,
  /** WEBHOOK_ATTEMPT_OUTCOME_SERVER_ERROR - 5xx */
  WEBHOOK_ATTEMPT_OUTCOME_SERVER_ERROR = 3,
  WEBHOOK_ATTEMPT_OUTCOME_TIMEOUT = 4,
  /** WEBHOOK_ATTEMPT_OUTCOME_CONNECTION_ERROR - DNS, refused, reset */
  WEBHOOK_ATTEMPT_OUTCOME_CONNECTION_ERROR = 5,
  WEBHOOK_ATTEMPT_OUTCOME_TLS_ERROR = 6,
  /** WEBHOOK_ATTEMPT_OUTCOME_REDIRECT - 3xx; redirects are not followed */
  WEBHOOK_ATTEMPT_OUTCOME_REDIRECT = 7,
  /** WEBHOOK_ATTEMPT_OUTCOME_BLOCKED_ADDRESS - resolved to a private or reserved address */
  WEBHOOK_ATTEMPT_OUTCOME_BLOCKED_ADDRESS = 8,
}

/** Kind of a manual action recorded on a delivery. */
export enum WebhookManualActionKind {
  WEBHOOK_MANUAL_ACTION_KIND_UNSPECIFIED = 0,
  WEBHOOK_MANUAL_ACTION_KIND_RETRY = 1,
  WEBHOOK_MANUAL_ACTION_KIND_RESEND = 2,
  WEBHOOK_MANUAL_ACTION_KIND_BULK_RETRY = 3,
  WEBHOOK_MANUAL_ACTION_KIND_REPLAY = 4,
  WEBHOOK_MANUAL_ACTION_KIND_CANCEL = 5,
}

/** Who performed a manual action. */
export enum WebhookActorKind {
  WEBHOOK_ACTOR_KIND_UNSPECIFIED = 0,
  /** WEBHOOK_ACTOR_KIND_CUSTOMER - an organization user (customer dashboard) */
  WEBHOOK_ACTOR_KIND_CUSTOMER = 1,
  /** WEBHOOK_ACTOR_KIND_STAFF - 100ms staff (admin dashboard) */
  WEBHOOK_ACTOR_KIND_STAFF = 2,
  /** WEBHOOK_ACTOR_KIND_SYSTEM - compass itself (e.g. replay on resume) */
  WEBHOOK_ACTOR_KIND_SYSTEM = 3,
}

export enum WebhookOperationKind {
  WEBHOOK_OPERATION_KIND_UNSPECIFIED = 0,
  WEBHOOK_OPERATION_KIND_BULK_RETRY = 1,
  WEBHOOK_OPERATION_KIND_REPLAY = 2,
}

export enum WebhookOperationState {
  WEBHOOK_OPERATION_STATE_UNSPECIFIED = 0,
  WEBHOOK_OPERATION_STATE_RUNNING = 1,
  WEBHOOK_OPERATION_STATE_DONE = 2,
  WEBHOOK_OPERATION_STATE_FAILED = 3,
}

/**
 * Which cases an endpoint receives events for. All set fields are AND-combined;
 * an empty repeated field means "any".
 */
export interface WebhookEndpointFilter {
  /**
   * Integration client slug (case.source.client), e.g. "knipper". Admin only;
   * customer-created endpoints never set it.
   */
  source_client?: string | undefined;
  /**
   * Only cases of this organization. Customer endpoints always have it set to
   * their own organization.
   */
  filter_organization_id?: string | undefined;
  /** Only cases of these programs. */
  program_ids?: string[] | undefined;
  /** Only cases of these workflow types (e.g. "pbm", "unifiedmedbv"). */
  workflow_types?: string[] | undefined;
}

/** Metadata of a signing secret. The secret itself is never returned here. */
export interface WebhookSigningSecretInfo {
  id?: string | undefined;
  /** Masked hint for recognizing the secret, e.g. "whsec_…abcd". */
  hint?: string | undefined;
  created_at?: string | undefined;
  /** Set on a rotated-out secret: it keeps signing until this time. */
  expires_at?: string | undefined;
}

/** A configured custom header. Values are write-only and never returned. */
export interface WebhookCustomHeaderInfo {
  name?: string | undefined;
}

/** A custom header in a create or update request. Values are write-only. */
export interface WebhookCustomHeaderInput {
  name?: string | undefined;
  /**
   * The header value; required on create. On update, leaving it unset keeps
   * the stored value for an existing header name (InvalidArgument if the name
   * is new). Headers missing from an update request are removed.
   */
  value?: string | undefined;
}

/**
 * A webhook endpoint as returned by the API. Never contains secrets or
 * custom header values.
 */
export interface WebhookEndpoint {
  id?: string | undefined;
  /** Owner organization. */
  organization_id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  environment?: WebhookEnvironment | undefined;
  url?: string | undefined;
  /** Host part of url, for display. */
  url_host?: string | undefined;
  status?: WebhookEndpointStatus | undefined;
  /**
   * Subscribed event types, e.g. "case.created.success", "case.completed".
   * "webhook.test" is always allowed and never listed.
   */
  event_types?: string[] | undefined;
  filter?: WebhookEndpointFilter | undefined;
  /** Send payloads without referenceId. */
  omit_reference_id?: boolean | undefined;
  /** Current secret plus any rotated-out secret still in its overlap window. */
  signing_secrets?: WebhookSigningSecretInfo[] | undefined;
  custom_headers?: WebhookCustomHeaderInfo[] | undefined;
  /** Per-attempt HTTP timeout. */
  timeout_seconds?: number | undefined;
  /** Optimistic-lock version; send it back on update. */
  version?: number | undefined;
  /** Set while the endpoint is paused. */
  paused_at?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
  /** User ids. */
  created_by?: string | undefined;
  updated_by?: string | undefined;
  /**
   * True when the endpoint is managed by 100ms support (its filter has a
   * source_client). Customers can read it and retry its deliveries but
   * cannot update, delete, pause, disable, resume, rotate, test or replay it.
   */
  managed?: boolean | undefined;
}

/** Delivery health of one endpoint over the dispatcher's window. */
export interface WebhookEndpointHealth {
  endpoint_id?: string | undefined;
  attempts?: number | undefined;
  /** 0.0 to 1.0; unset when there were no attempts. */
  success_rate?: number | undefined;
  p95_latency_ms?: number | undefined;
  last_success_at?: string | undefined;
  consecutive_failures?: number | undefined;
  /** Deliveries currently retrying / exhausted. */
  retrying?: number | undefined;
  exhausted?: number | undefined;
  /** Oldest delivery not yet delivered (backlog age). */
  oldest_undelivered_at?: string | undefined;
}

/** One delivery of one event to one endpoint. */
export interface WebhookDelivery {
  id?: string | undefined;
  event_id?: string | undefined;
  event_type?: string | undefined;
  occurred_at?: string | undefined;
  endpoint_id?: string | undefined;
  /** Filled by compass from its endpoint store; empty if the endpoint was deleted. */
  endpoint_name?: string | undefined;
  /** Endpoint owner organization. */
  organization_id?: string | undefined;
  environment?: WebhookEnvironment | undefined;
  url_host?: string | undefined;
  status?: WebhookDeliveryStatus | undefined;
  attempt_count?: number | undefined;
  /** 0 when no HTTP response was received. */
  last_status_code?: number | undefined;
  last_outcome?: WebhookAttemptOutcome | undefined;
  /** Machine-readable failure class, e.g. "timeout", "invalid_url". */
  last_error_class?: string | undefined;
  /** Why a cancelled delivery was cancelled, e.g. "endpoint_paused". */
  cancel_reason?: string | undefined;
  /** Automatic retries left; unset when not applicable (terminal states). */
  retries_left?: number | undefined;
  created_at?: string | undefined;
  next_attempt_at?: string | undefined;
  succeeded_at?: string | undefined;
  /** Retries stop at this time. */
  deadline?: string | undefined;
  /** Search aids from the event's lookup keys. */
  case_id?: string | undefined;
  reference_id?: string | undefined;
  source_client?: string | undefined;
}

/** One HTTP attempt of a delivery. */
export interface WebhookAttempt {
  number?: number | undefined;
  started_at?: string | undefined;
  latency_ms?: number | undefined;
  /** 0 when no HTTP response was received. */
  status_code?: number | undefined;
  outcome?: WebhookAttemptOutcome | undefined;
  /** Response bodies are never stored, only their size. */
  response_size_bytes?: number | undefined;
}

/** A manual action recorded on a delivery. */
export interface WebhookManualAction {
  kind?: WebhookManualActionKind | undefined;
  actor_kind?: WebhookActorKind | undefined;
  actor_user_id?: string | undefined;
  /** Blank for STAFF actors in organization-scoped responses. */
  actor_email?: string | undefined;
  at?: string | undefined;
  /** Set for bulk retry and replay. */
  operation_id?: string | undefined;
}

/** A delivery with everything needed to inspect it. */
export interface WebhookDeliveryDetail {
  delivery?: WebhookDelivery | undefined;
  /** The exact JSON payload that was signed and sent (ids only, no PHI). */
  event_json?: string | undefined;
  /** Oldest first; the dispatcher keeps the last 50. */
  attempts?: WebhookAttempt[] | undefined;
  manual_actions?: WebhookManualAction[] | undefined;
  /**
   * The delivery's Temporal workflow and run ids in the dispatcher's
   * namespace, for support debugging. Admin responses only; compass does
   * not know the namespace and builds no link.
   */
  temporal_workflow_id?: string | undefined;
  temporal_run_id?: string | undefined;
}

/** A bulk retry or replay operation. */
export interface WebhookOperation {
  id?: string | undefined;
  kind?: WebhookOperationKind | undefined;
  state?: WebhookOperationState | undefined;
  /** Deliveries selected / started / skipped so far. */
  total?: number | undefined;
  started?: number | undefined;
  skipped?: number | undefined;
  /** Deliveries started per second. */
  rate_per_second?: number | undefined;
  created_at?: string | undefined;
  finished_at?: string | undefined;
  /** Failure reason when state is FAILED. */
  error?: string | undefined;
}

export interface ListWebhookEndpointsRequest {
  organization_id?: string | undefined;
  /** Optional filters; UNSPECIFIED means any. */
  environment?: WebhookEnvironment | undefined;
  status?: WebhookEndpointStatus | undefined;
}

export interface ListWebhookEndpointsResponse {
  endpoints?: WebhookEndpoint[] | undefined;
}

export interface CreateWebhookEndpointRequest {
  organization_id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  environment?: WebhookEnvironment | undefined;
  /** HTTPS URL of the receiver. */
  url?: string | undefined;
  /** At least one subscribed event type. */
  event_types?: string[] | undefined;
  /** Optional narrowing within the organization; empty means all. */
  program_ids?: string[] | undefined;
  workflow_types?: string[] | undefined;
  /** Every value is required on create. */
  custom_headers?: WebhookCustomHeaderInput[] | undefined;
  /** Per-attempt timeout; 0 means the server default. */
  timeout_seconds?: number | undefined;
  omit_reference_id?: boolean | undefined;
}

export interface CreateWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** The signing secret. Shown once; never returned again. */
  signing_secret?: string | undefined;
}

export interface GetWebhookEndpointRequest {
  organization_id?: string | undefined;
  endpoint_id?: string | undefined;
}

/** Response of GetWebhookEndpoint. */
export interface GetWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
}

/** Full replace of the editable fields: every field is applied as sent. */
export interface UpdateWebhookEndpointRequest {
  organization_id?: string | undefined;
  endpoint_id?: string | undefined;
  /** Must equal the stored version; otherwise Aborted (HTTP 409). */
  version?: number | undefined;
  name?: string | undefined;
  description?: string | undefined;
  environment?: WebhookEnvironment | undefined;
  url?: string | undefined;
  event_types?: string[] | undefined;
  program_ids?: string[] | undefined;
  workflow_types?: string[] | undefined;
  /** The complete header set. A header without value keeps its stored value. */
  custom_headers?: WebhookCustomHeaderInput[] | undefined;
  timeout_seconds?: number | undefined;
  omit_reference_id?: boolean | undefined;
}

/** Response of UpdateWebhookEndpoint: the endpoint as stored after the update. */
export interface UpdateWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
}

export interface DeleteWebhookEndpointRequest {
  organization_id?: string | undefined;
  endpoint_id?: string | undefined;
}

export interface DeleteWebhookEndpointResponse {
  /**
   * True when the endpoint was deleted but cancelling its pending deliveries
   * at the dispatcher failed.
   */
  dispatcher_error?: boolean | undefined;
}

export interface PauseWebhookEndpointRequest {
  organization_id?: string | undefined;
  endpoint_id?: string | undefined;
}

export interface PauseWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** Pending deliveries cancelled at the dispatcher. */
  cancelled_deliveries?: number | undefined;
  /** True when the status changed but the dispatcher could not be reached. */
  dispatcher_error?: boolean | undefined;
}

export interface DisableWebhookEndpointRequest {
  organization_id?: string | undefined;
  endpoint_id?: string | undefined;
}

export interface DisableWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** Pending deliveries cancelled at the dispatcher. */
  cancelled_deliveries?: number | undefined;
  /** True when the status changed but the dispatcher could not be reached. */
  dispatcher_error?: boolean | undefined;
}

export interface ResumeWebhookEndpointRequest {
  organization_id?: string | undefined;
  endpoint_id?: string | undefined;
}

export interface ResumeWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** Replay operation started when resuming from paused; empty otherwise. */
  replay_operation_id?: string | undefined;
  /** True when the endpoint was resumed but the replay could not be started. */
  dispatcher_error?: boolean | undefined;
}

export interface RotateWebhookEndpointSecretRequest {
  organization_id?: string | undefined;
  endpoint_id?: string | undefined;
}

export interface RotateWebhookEndpointSecretResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** The new signing secret. Shown once; never returned again. */
  signing_secret?: string | undefined;
}

export interface SendWebhookTestEventRequest {
  organization_id?: string | undefined;
  endpoint_id?: string | undefined;
}

export interface SendWebhookTestEventResponse {
  event_id?: string | undefined;
  delivery_id?: string | undefined;
}

export interface ReplayWebhookWindowRequest {
  organization_id?: string | undefined;
  endpoint_id?: string | undefined;
  /** Window of event occurred_at; from must be before to. */
  from?: string | undefined;
  to?: string | undefined;
  /** Empty means every subscribed type. */
  event_types?: string[] | undefined;
  /** Only events whose delivery did not succeed. */
  undelivered_only?: boolean | undefined;
  /** Count only; nothing is sent. Returns a DONE operation with total set. */
  dry_run?: boolean | undefined;
}

/** Response of ReplayWebhookWindow: the started replay operation (DONE with total set on a dry run). */
export interface ReplayWebhookWindowResponse {
  operation?: WebhookOperation | undefined;
}

export interface GetWebhookEndpointHealthRequest {
  organization_id?: string | undefined;
  /** 1 to 100 endpoint ids (query: endpoint_ids=a&endpoint_ids=b or comma-separated). */
  endpoint_ids?: string[] | undefined;
}

export interface GetWebhookEndpointHealthResponse {
  endpoints?: WebhookEndpointHealth[] | undefined;
}

/**
 * All filters are optional and AND-combined. Repeated filters accept repeated
 * query params or comma-separated values; enums are numeric; times are RFC3339.
 */
export interface ListWebhookDeliveriesRequest {
  organization_id?: string | undefined;
  endpoint_ids?: string[] | undefined;
  statuses?: WebhookDeliveryStatus[] | undefined;
  event_types?: string[] | undefined;
  case_id?: string | undefined;
  reference_id?: string | undefined;
  environment?: WebhookEnvironment | undefined;
  occurred_after?: string | undefined;
  occurred_before?: string | undefined;
  /** Page size; default 50, maximum 100. */
  limit?: number | undefined;
  /** Cursor from a previous response's next_cursor. */
  start?: string | undefined;
}

export interface ListWebhookDeliveriesResponse {
  deliveries?: WebhookDelivery[] | undefined;
  /** Opaque cursor for the next page; empty on the last page. */
  next_cursor?: string | undefined;
}

/**
 * Exactly one target: delivery_ids, or endpoint_id (with optional statuses and
 * time window). Only retrying and exhausted deliveries are retried.
 */
export interface BulkRetryWebhookDeliveriesRequest {
  organization_id?: string | undefined;
  delivery_ids?: string[] | undefined;
  endpoint_id?: string | undefined;
  statuses?: WebhookDeliveryStatus[] | undefined;
  occurred_after?: string | undefined;
  occurred_before?: string | undefined;
}

/** Response of BulkRetryWebhookDeliveries: the started bulk-retry operation. */
export interface BulkRetryWebhookDeliveriesResponse {
  operation?: WebhookOperation | undefined;
}

export interface GetWebhookDeliveryRequest {
  organization_id?: string | undefined;
  delivery_id?: string | undefined;
}

/** Response of GetWebhookDelivery: the delivery with its event payload and attempts. */
export interface GetWebhookDeliveryResponse {
  detail?: WebhookDeliveryDetail | undefined;
}

export interface RetryWebhookDeliveryRequest {
  organization_id?: string | undefined;
  delivery_id?: string | undefined;
}

/** Response of RetryWebhookDelivery: the delivery after it was re-queued. */
export interface RetryWebhookDeliveryResponse {
  delivery?: WebhookDelivery | undefined;
}

export interface GetWebhookOperationRequest {
  organization_id?: string | undefined;
  operation_id?: string | undefined;
}

/** Response of GetWebhookOperation. */
export interface GetWebhookOperationResponse {
  operation?: WebhookOperation | undefined;
}

export interface AdminListWebhookEndpointsRequest {
  /**
   * Optional filters; empty / UNSPECIFIED means any.
   * Matches endpoints owned by this organization.
   */
  filter_organization_id?: string | undefined;
  environment?: WebhookEnvironment | undefined;
  status?: WebhookEndpointStatus | undefined;
  /** Matches endpoints whose filter.source_client equals this. */
  source_client?: string | undefined;
}

/** Response of AdminListWebhookEndpoints; same JSON shape as ListWebhookEndpointsResponse. */
export interface AdminListWebhookEndpointsResponse {
  endpoints?: WebhookEndpoint[] | undefined;
}

export interface AdminCreateWebhookEndpointRequest {
  /** Organization that owns the endpoint (and its deliveries). */
  owner_organization_id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  environment?: WebhookEnvironment | undefined;
  url?: string | undefined;
  event_types?: string[] | undefined;
  /** Must set source_client and/or filter_organization_id. */
  filter?: WebhookEndpointFilter | undefined;
  /** Every value is required on create. */
  custom_headers?: WebhookCustomHeaderInput[] | undefined;
  timeout_seconds?: number | undefined;
  omit_reference_id?: boolean | undefined;
}

/** Response of AdminCreateWebhookEndpoint; same JSON shape as CreateWebhookEndpointResponse. */
export interface AdminCreateWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** The signing secret. Shown once; never returned again. */
  signing_secret?: string | undefined;
}

export interface AdminGetWebhookEndpointRequest {
  endpoint_id?: string | undefined;
}

/** Response of AdminGetWebhookEndpoint; same JSON shape as GetWebhookEndpointResponse. */
export interface AdminGetWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
}

/** Full replace of the editable fields (the owner organization is fixed). */
export interface AdminUpdateWebhookEndpointRequest {
  endpoint_id?: string | undefined;
  /** Must equal the stored version; otherwise Aborted (HTTP 409). */
  version?: number | undefined;
  name?: string | undefined;
  description?: string | undefined;
  environment?: WebhookEnvironment | undefined;
  url?: string | undefined;
  event_types?: string[] | undefined;
  /** Must set source_client and/or filter_organization_id. */
  filter?: WebhookEndpointFilter | undefined;
  /** The complete header set. A header without value keeps its stored value. */
  custom_headers?: WebhookCustomHeaderInput[] | undefined;
  timeout_seconds?: number | undefined;
  omit_reference_id?: boolean | undefined;
}

/** Response of AdminUpdateWebhookEndpoint; same JSON shape as UpdateWebhookEndpointResponse. */
export interface AdminUpdateWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
}

export interface AdminDeleteWebhookEndpointRequest {
  endpoint_id?: string | undefined;
}

/** Response of AdminDeleteWebhookEndpoint; same JSON shape as DeleteWebhookEndpointResponse. */
export interface AdminDeleteWebhookEndpointResponse {
  /**
   * True when the endpoint was deleted but cancelling its pending deliveries
   * at the dispatcher failed.
   */
  dispatcher_error?: boolean | undefined;
}

export interface AdminPauseWebhookEndpointRequest {
  endpoint_id?: string | undefined;
}

/** Response of AdminPauseWebhookEndpoint; same JSON shape as PauseWebhookEndpointResponse. */
export interface AdminPauseWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** Pending deliveries cancelled at the dispatcher. */
  cancelled_deliveries?: number | undefined;
  /** True when the status changed but the dispatcher could not be reached. */
  dispatcher_error?: boolean | undefined;
}

export interface AdminDisableWebhookEndpointRequest {
  endpoint_id?: string | undefined;
}

/** Response of AdminDisableWebhookEndpoint; same JSON shape as DisableWebhookEndpointResponse. */
export interface AdminDisableWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** Pending deliveries cancelled at the dispatcher. */
  cancelled_deliveries?: number | undefined;
  /** True when the status changed but the dispatcher could not be reached. */
  dispatcher_error?: boolean | undefined;
}

export interface AdminResumeWebhookEndpointRequest {
  endpoint_id?: string | undefined;
}

/** Response of AdminResumeWebhookEndpoint; same JSON shape as ResumeWebhookEndpointResponse. */
export interface AdminResumeWebhookEndpointResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** Replay operation started when resuming from paused; empty otherwise. */
  replay_operation_id?: string | undefined;
  /** True when the endpoint was resumed but the replay could not be started. */
  dispatcher_error?: boolean | undefined;
}

export interface AdminRotateWebhookEndpointSecretRequest {
  endpoint_id?: string | undefined;
}

/** Response of AdminRotateWebhookEndpointSecret; same JSON shape as RotateWebhookEndpointSecretResponse. */
export interface AdminRotateWebhookEndpointSecretResponse {
  endpoint?: WebhookEndpoint | undefined;
  /** The new signing secret. Shown once; never returned again. */
  signing_secret?: string | undefined;
}

export interface AdminSendWebhookTestEventRequest {
  endpoint_id?: string | undefined;
}

/** Response of AdminSendWebhookTestEvent; same JSON shape as SendWebhookTestEventResponse. */
export interface AdminSendWebhookTestEventResponse {
  event_id?: string | undefined;
  delivery_id?: string | undefined;
}

export interface AdminReplayWebhookWindowRequest {
  endpoint_id?: string | undefined;
  /** Window of event occurred_at; from must be before to. */
  from?: string | undefined;
  to?: string | undefined;
  /** Empty means every subscribed type. */
  event_types?: string[] | undefined;
  /** Only events whose delivery did not succeed. */
  undelivered_only?: boolean | undefined;
  /** Count only; nothing is sent. Returns a DONE operation with total set. */
  dry_run?: boolean | undefined;
}

/** Response of AdminReplayWebhookWindow; same JSON shape as ReplayWebhookWindowResponse. */
export interface AdminReplayWebhookWindowResponse {
  operation?: WebhookOperation | undefined;
}

export interface AdminGetWebhookEndpointHealthRequest {
  /** 1 to 100 endpoint ids. */
  endpoint_ids?: string[] | undefined;
}

/** Response of AdminGetWebhookEndpointHealth; same JSON shape as GetWebhookEndpointHealthResponse. */
export interface AdminGetWebhookEndpointHealthResponse {
  endpoints?: WebhookEndpointHealth[] | undefined;
}

/**
 * All filters are optional and AND-combined (same query conventions as
 * ListWebhookDeliveriesRequest).
 */
export interface AdminListWebhookDeliveriesRequest {
  /** Deliveries of endpoints owned by this organization. */
  filter_organization_id?: string | undefined;
  /** Deliveries of events whose case came from this integration client. */
  source_client?: string | undefined;
  endpoint_ids?: string[] | undefined;
  statuses?: WebhookDeliveryStatus[] | undefined;
  event_types?: string[] | undefined;
  case_id?: string | undefined;
  reference_id?: string | undefined;
  environment?: WebhookEnvironment | undefined;
  occurred_after?: string | undefined;
  occurred_before?: string | undefined;
  /** Page size; default 50, maximum 100. */
  limit?: number | undefined;
  /** Cursor from a previous response's next_cursor. */
  start?: string | undefined;
}

/** Response of AdminListWebhookDeliveries; same JSON shape as ListWebhookDeliveriesResponse. */
export interface AdminListWebhookDeliveriesResponse {
  deliveries?: WebhookDelivery[] | undefined;
  /** Opaque cursor for the next page; empty on the last page. */
  next_cursor?: string | undefined;
}

/**
 * Exactly one target: delivery_ids, or endpoint_id (with optional statuses and
 * time window). Only retrying and exhausted deliveries are retried.
 */
export interface AdminBulkRetryWebhookDeliveriesRequest {
  /** Optional: narrows the dispatcher scope to this owner organization. */
  filter_organization_id?: string | undefined;
  delivery_ids?: string[] | undefined;
  endpoint_id?: string | undefined;
  statuses?: WebhookDeliveryStatus[] | undefined;
  occurred_after?: string | undefined;
  occurred_before?: string | undefined;
}

/** Response of AdminBulkRetryWebhookDeliveries; same JSON shape as BulkRetryWebhookDeliveriesResponse. */
export interface AdminBulkRetryWebhookDeliveriesResponse {
  operation?: WebhookOperation | undefined;
}

export interface AdminGetWebhookDeliveryRequest {
  delivery_id?: string | undefined;
}

/** Response of AdminGetWebhookDelivery; same JSON shape as GetWebhookDeliveryResponse. */
export interface AdminGetWebhookDeliveryResponse {
  detail?: WebhookDeliveryDetail | undefined;
}

export interface AdminRetryWebhookDeliveryRequest {
  delivery_id?: string | undefined;
}

/** Response of AdminRetryWebhookDelivery; same JSON shape as RetryWebhookDeliveryResponse. */
export interface AdminRetryWebhookDeliveryResponse {
  delivery?: WebhookDelivery | undefined;
}

export interface AdminGetWebhookOperationRequest {
  operation_id?: string | undefined;
}

/** Response of AdminGetWebhookOperation; same JSON shape as GetWebhookOperationResponse. */
export interface AdminGetWebhookOperationResponse {
  operation?: WebhookOperation | undefined;
}

/**
 * WebhookService manages an organization's outbound webhook endpoints and
 * their deliveries. Every RPC is scoped to the organization in the path; an
 * endpoint, delivery or operation of another organization answers NotFound.
 * Endpoint management works without the dispatcher (iris); delivery RPCs answer
 * Unavailable when it is not configured. When the server-wide webhooks switch
 * is off, every RPC answers FailedPrecondition.
 */
export interface WebhookService {
  /** Lists the organization's webhook endpoints (deleted endpoints are never returned). */
  listWebhookEndpoints(request: ListWebhookEndpointsRequest): Promise<ListWebhookEndpointsResponse>;
  /**
   * Creates an endpoint scoped to the path organization. The signing secret is
   * returned once in the response and never again.
   */
  createWebhookEndpoint(
    request: CreateWebhookEndpointRequest,
  ): Promise<CreateWebhookEndpointResponse>;
  /** Gets one endpoint. NotFound when it belongs to another organization. */
  getWebhookEndpoint(request: GetWebhookEndpointRequest): Promise<GetWebhookEndpointResponse>;
  /**
   * Replaces the editable fields of an endpoint. version must equal the stored
   * version (optimistic lock); a stale version returns Aborted (HTTP 409).
   */
  updateWebhookEndpoint(
    request: UpdateWebhookEndpointRequest,
  ): Promise<UpdateWebhookEndpointResponse>;
  /** Deletes an endpoint and best-effort cancels its pending deliveries. */
  deleteWebhookEndpoint(
    request: DeleteWebhookEndpointRequest,
  ): Promise<DeleteWebhookEndpointResponse>;
  /**
   * Pauses an endpoint. New events are still recorded (as cancelled with reason
   * endpoint_paused) so Resume can replay them; pending deliveries are cancelled.
   */
  pauseWebhookEndpoint(request: PauseWebhookEndpointRequest): Promise<PauseWebhookEndpointResponse>;
  /**
   * Disables an endpoint. It stops matching events entirely; pending deliveries
   * are cancelled. Resuming a disabled endpoint does not replay.
   */
  disableWebhookEndpoint(
    request: DisableWebhookEndpointRequest,
  ): Promise<DisableWebhookEndpointResponse>;
  /**
   * Re-activates a paused or disabled endpoint. From paused, it also starts a
   * replay of undelivered events since the pause.
   */
  resumeWebhookEndpoint(
    request: ResumeWebhookEndpointRequest,
  ): Promise<ResumeWebhookEndpointResponse>;
  /**
   * Issues a new signing secret. The previous secret keeps signing for the
   * configured overlap window. The new secret is returned once.
   */
  rotateWebhookEndpointSecret(
    request: RotateWebhookEndpointSecretRequest,
  ): Promise<RotateWebhookEndpointSecretResponse>;
  /** Sends a webhook.test event to the endpoint. */
  sendWebhookTestEvent(request: SendWebhookTestEventRequest): Promise<SendWebhookTestEventResponse>;
  /**
   * Re-sends the endpoint's events from a time window. The endpoint must be
   * active (FailedPrecondition otherwise).
   */
  replayWebhookWindow(request: ReplayWebhookWindowRequest): Promise<ReplayWebhookWindowResponse>;
  /** Delivery health of the given endpoints over the dispatcher's default window. */
  getWebhookEndpointHealth(
    request: GetWebhookEndpointHealthRequest,
  ): Promise<GetWebhookEndpointHealthResponse>;
  /** Lists deliveries of the organization's endpoints, newest first. */
  listWebhookDeliveries(
    request: ListWebhookDeliveriesRequest,
  ): Promise<ListWebhookDeliveriesResponse>;
  /**
   * Retries many deliveries at once: either explicit delivery_ids, or an
   * endpoint_id with optional status/time filters (exactly one of the two).
   */
  bulkRetryWebhookDeliveries(
    request: BulkRetryWebhookDeliveriesRequest,
  ): Promise<BulkRetryWebhookDeliveriesResponse>;
  /** Gets one delivery with its payload, attempts and manual actions. */
  getWebhookDelivery(request: GetWebhookDeliveryRequest): Promise<GetWebhookDeliveryResponse>;
  /** Retries one delivery now with the endpoint's current configuration. */
  retryWebhookDelivery(request: RetryWebhookDeliveryRequest): Promise<RetryWebhookDeliveryResponse>;
  /** Progress of a bulk retry or replay operation. */
  getWebhookOperation(request: GetWebhookOperationRequest): Promise<GetWebhookOperationResponse>;
}

/**
 * AdminWebhookService is the cross-organization (global scope) counterpart of
 * WebhookService for 100ms staff. Requests never carry a field named
 * organization_id: owner and filter organizations are explicit
 * (owner_organization_id, filter_organization_id).
 */
export interface AdminWebhookService {
  /** Lists endpoints across organizations, optionally filtered. */
  adminListWebhookEndpoints(
    request: AdminListWebhookEndpointsRequest,
  ): Promise<AdminListWebhookEndpointsResponse>;
  /**
   * Creates an endpoint owned by owner_organization_id. The filter must set
   * source_client and/or filter_organization_id. The signing secret is returned once.
   */
  adminCreateWebhookEndpoint(
    request: AdminCreateWebhookEndpointRequest,
  ): Promise<AdminCreateWebhookEndpointResponse>;
  /** Gets any endpoint. */
  adminGetWebhookEndpoint(
    request: AdminGetWebhookEndpointRequest,
  ): Promise<AdminGetWebhookEndpointResponse>;
  /** Replaces the editable fields of any endpoint (optimistic lock on version). */
  adminUpdateWebhookEndpoint(
    request: AdminUpdateWebhookEndpointRequest,
  ): Promise<AdminUpdateWebhookEndpointResponse>;
  /** Deletes any endpoint. */
  adminDeleteWebhookEndpoint(
    request: AdminDeleteWebhookEndpointRequest,
  ): Promise<AdminDeleteWebhookEndpointResponse>;
  /** Pauses any endpoint. */
  adminPauseWebhookEndpoint(
    request: AdminPauseWebhookEndpointRequest,
  ): Promise<AdminPauseWebhookEndpointResponse>;
  /** Disables any endpoint. */
  adminDisableWebhookEndpoint(
    request: AdminDisableWebhookEndpointRequest,
  ): Promise<AdminDisableWebhookEndpointResponse>;
  /** Resumes any endpoint (replays since the pause when resuming from paused). */
  adminResumeWebhookEndpoint(
    request: AdminResumeWebhookEndpointRequest,
  ): Promise<AdminResumeWebhookEndpointResponse>;
  /** Rotates the signing secret of any endpoint. The new secret is returned once. */
  adminRotateWebhookEndpointSecret(
    request: AdminRotateWebhookEndpointSecretRequest,
  ): Promise<AdminRotateWebhookEndpointSecretResponse>;
  /** Sends a webhook.test event to any endpoint. */
  adminSendWebhookTestEvent(
    request: AdminSendWebhookTestEventRequest,
  ): Promise<AdminSendWebhookTestEventResponse>;
  /** Replays a time window for any endpoint. */
  adminReplayWebhookWindow(
    request: AdminReplayWebhookWindowRequest,
  ): Promise<AdminReplayWebhookWindowResponse>;
  /** Delivery health of any endpoints. */
  adminGetWebhookEndpointHealth(
    request: AdminGetWebhookEndpointHealthRequest,
  ): Promise<AdminGetWebhookEndpointHealthResponse>;
  /** Lists deliveries across organizations, newest first. */
  adminListWebhookDeliveries(
    request: AdminListWebhookDeliveriesRequest,
  ): Promise<AdminListWebhookDeliveriesResponse>;
  /** Bulk retry across organizations (delivery_ids XOR endpoint filter). */
  adminBulkRetryWebhookDeliveries(
    request: AdminBulkRetryWebhookDeliveriesRequest,
  ): Promise<AdminBulkRetryWebhookDeliveriesResponse>;
  /** Gets any delivery, including its Temporal workflow and run ids. */
  adminGetWebhookDelivery(
    request: AdminGetWebhookDeliveryRequest,
  ): Promise<AdminGetWebhookDeliveryResponse>;
  /** Retries any delivery. */
  adminRetryWebhookDelivery(
    request: AdminRetryWebhookDeliveryRequest,
  ): Promise<AdminRetryWebhookDeliveryResponse>;
  /** Progress of any bulk retry or replay operation. */
  adminGetWebhookOperation(
    request: AdminGetWebhookOperationRequest,
  ): Promise<AdminGetWebhookOperationResponse>;
}
